import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=7a38a16e&scoped=true&"
import script from "./_slugControl.js?vue&type=script&lang=js&"
export * from "./_slugControl.js?vue&type=script&lang=js&"
import style0 from "./_slug.css?vue&type=style&index=0&id=7a38a16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38a16e",
  null
  
)

export default component.exports